import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { UrlApi } from "../../../../../services/apirest";
import { registrarAccion, DONDE } from "../../../logs/registrarAccion";

// Anula una venta sólo con envases (estado 366) pasándola a anulado (271).
// remito_envase y recibo_envase se conservan como referencia.
function AnularSoloEnvases(props) {
  const [disBtn, setDisBtn] = useState(false);

  const handleClose = () => {
    props.onClose(false);
  };

  const anularVenta = async (e) => {
    e.preventDefault();
    setDisBtn(true);
    const remito = props.factura.remito_envase ? " (remito N°" + props.factura.remito_envase + ")" : "";
    const msj = "Venta solo envases" + remito + " anulada por " + localStorage.getItem("user");
    try {
      const response = await fetch(`${UrlApi}/envasado_pedidos/${props.factura.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ estado: 271, obs_anulado: msj }),
      });
      if (!response.ok) {
        throw new Error(`Error ${response.status}`);
      }
      registrarAccion(DONDE.RENDICIONES, "Anuló venta solo envases del pedido N°" + props.factura.id + remito);
    } catch (error) {
      console.error("Error en la solicitud:", error.message);
      alert("Error al anular la venta: " + error.message);
    } finally {
      handleClose();
    }
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        <form>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                Anulación de Venta: Pedido N°{props.factura.id}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            <DialogContentText textAlign={"center"}>
              ¿Seguro que quiere anular la venta?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack spacing={45} direction="row">
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                color="success"
                type="submit"
                variant="contained"
                disabled={disBtn}
                onClick={anularVenta}
              >
                Confirmar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default AnularSoloEnvases;
